export default {
      id: "ic_galaxy_store-usage",
      viewBox: "0 0 130 40",
      url: "/" + "images/icons.3.109.2.svg#ic_galaxy_store-usage",
      toString: function () {
        return this.url;
      }
    }